export default function fieldDefaultValue(fieldType, options = {}) {
  switch (fieldType) {
    // checkbox is the one that should always have a value (Hasan says so!)
    case 'checkbox':
      return {}

    case 'multiple_select':
      return []

    case 'file':
      return options?.allow_multiple_files ? [] : ''

    default:
      return undefined
  }
}
